module.exports = __webpack_public_path__ + "img/logo-2.1bd11396.png";